import { render, staticRenderFns } from "./kds.vue?vue&type=template&id=5e88b253"
import script from "./kds.vue?vue&type=script&lang=js"
export * from "./kds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e88b253')) {
      api.createRecord('5e88b253', component.options)
    } else {
      api.reload('5e88b253', component.options)
    }
    module.hot.accept("./kds.vue?vue&type=template&id=5e88b253", function () {
      api.rerender('5e88b253', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/kds.vue"
export default component.exports